import React from "react";
import { Field, FastField } from "formik";
import get from "lodash.get";
import PasswordInput from "../../../../../../ui/widgets/password-input";
import { TextInputProps } from "../../../../../../ui/widgets/text-input/types";

interface TextInputWrapperPropsType extends TextInputProps {
  field: {
    name: string;
    value?: string | number;
  };
}

const PasswordWrapper = ({
  field,
  ...props
}: TextInputWrapperPropsType): React.JSX.Element => {
  const error = get(props, `form.errors.${field.name}`);
  const touched = get(props, `form.touched.${field.name}`);
  return (
    <PasswordInput
      id={field.name}
      {...field}
      {...props}
      error={!!(error && touched)}
      helperText={touched && error}
      type="password"
    />
  );
};

export default function TextInputField(
  props: TextInputProps,
): React.JSX.Element {
  return props.forceReRender ? (
    <Field component={PasswordWrapper} {...props} />
  ) : (
    <FastField component={PasswordWrapper} {...props} />
  );
}
